var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticStyle:{"height":"50%","width":"50%"}},[_c('v-img',{attrs:{"id":"tupp","src":require('@/assets/tupptupp.png')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }